"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VideoOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoOff_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.693 4.186c.2-.201.198-.532-.04-.69A2.986 2.986 0 0 0 8 3H1.5A1.5 1.5 0 0 0 0 4.5V10c0 .915.41 1.735 1.056 2.285.17.145.42.117.579-.042.227-.227.163-.614-.062-.843A1.994 1.994 0 0 1 1 10V4.5a.5.5 0 0 1 .5-.5H8c.348 0 .675.09.96.246.237.13.542.13.733-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.146.146a.5.5 0 0 1 .708.708L10.987 5.72c.008.092.013.186.013.28v5.5A1.5 1.5 0 0 1 9.5 13H3.707L.854 15.854a.5.5 0 0 1-.708-.708l15-15ZM10 6.707 4.707 12H9.5a.5.5 0 0 0 .5-.5V6.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.576 3.825a.752.752 0 0 0-.776.074l-2.6 1.944a.501.501 0 0 0 .6.8L15 5v6.002l-2.2-1.644a.5.5 0 0 0-.6.8l2.6 1.944a.752.752 0 0 0 1.2-.6V4.499c0-.351-.22-.58-.424-.674Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoOff_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VideoOff;
exports["default"] = _default;